import styles from "./TransactionTimeline.module.css";
import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";

/* Loading skeleton for the transaction timeline component
  This component displays a skeleton loader while the transaction data is being fetched.
  @returns A ReactElement representing the loading skeleton for the TransactionTimeline.
*/
export const TransactionTimelineLoadingSkeleton = () => {
  return (
    <>
      <SkeletonLoader
        height={6}
        width={60}
        rounding="sm"
        variant="rectangular"
      />
      <SkeletonLoader
        height={80}
        rounding="sm"
        variant="rectangular"
        extraClasses={styles.timelineLoadingSkeleton}
      />
    </>
  );
};
